/**
 * The two letters an avatar falls back to when there is no picture.
 *
 * `'?'` rather than an empty string when there is nothing to take: an avatar
 * with no content is a grey disc that reads as a rendering bug, and rows with a
 * missing name are exactly the ones an admin is looking for.
 *
 * Cross-feature because three places already needed it (the account header, the
 * edit-administrator dialog, and the Users index's identity cell) and the first
 * two each carried their own copy.
 */
export function initialsOf(firstName: string, lastName: string): string {
  const initials = `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}`.toUpperCase();
  return initials || '?';
}
